export default "__VITE_ASSET__CjJotRjT__"